import React, { useState, useEffect, useReducer } from "react";
import { instance } from "../../axios";
import { UiSelect, UiDatePicker, UiRSelect, TableZero, BgLoader, UiButton } from "../../ui.js";
import { useNavigate, useParams, useLocation, useOutletContext, useSearchParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import DataTable from 'react-data-table-component';
import { AiOutlineClose, AiOutlineSave } from "react-icons/ai";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { GoPencil } from "react-icons/go";
import { FaTrash } from "react-icons/fa";

import { toast } from "react-toastify";
import { useStore } from "../../state.js";
import Swal from "sweetalert2";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InfiniteScroll from 'react-infinite-scroll-component';
import { set } from "date-fns";
import placeholderimg from "../../placeholder.png";

export function UpdateItem(props) {

  const { content, key1 } = props;
  const [input_val, setInputval] = useState('');
  const [loader, setLoader] = useState(false);
  const listingModal = useModal('listing');

  const showModal = (id) => {
    listingModal.show({ id: id }).then((res) => {

    });


  }



  return (
    <div key={key1} className="mb-2">
      <div className="border bg-white p-3 rounded hover-shadow d-flex align-items-center" onClick={() => showModal(content.id)}>
      <div>
    <img src={content.image_url ? content.image_url : placeholderimg} alt={content.name} className="rounded me-3" style={{ width: '80px', height: '60px', objectFit: 'cover' }} />
        </div>
        <div>
        <h2 className="fs-6">{content.name}</h2>
        <small className="text-muted">{content.business_category}</small>
        </div>
      </div>

    </div>
  )
}
export default function Listings() {
  const location = useLocation();
  const { setTitle, search_visible } = useOutletContext();
  const queryParams = new URLSearchParams(location.search);
  let navigat = useNavigate();
  const [state, setState] = useState([]);
  const [page, setPage] = useState(1);
  const zstate = useStore((state) => state.groups);
  const setZState = useStore((state) => state.setGroups);
  const mstate = useStore((state) => state.machines);
  const settingState = useStore((state) => state.settings);
  const [u_items, setItems] = useState([]);
  const [isNextPageLoading, setisNextPageLoading] = useState(false);
  const [hasNextPage, sethasNextPage] = useState(false);
  const [elmheight, setElmheight] = useState(0);
  const [filters, setFilters] = useState('');
  const [searchParams] = useSearchParams();

  const filterModal = useModal('filter');
  const [filterText, setFilterText] = React.useState('');

  const showFilter = () => {
    filterModal.show({ filters: filters }).then((res) => {
      fetchData(res.filter);
      setFilters(res.filter)
      navigat("/listings?" + res.filter, { replace: true })
    });


  }
  const schema = yup.object().shape({

  });
  const {
    register,
    handleSubmit,
    control,
    unregister,
    getValues,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    setPage(1)
    fetchData();
    //reset();
  };




  const loadNextPage = () => {


    setisNextPageLoading(true)
    instance
      .get("/listings.php?page=" + u_items.length + "&" + queryParams.toString())
      .then(function (response) {


        setItems([...u_items, ...response.data.items])

        setisNextPageLoading(false)
        if (response.data.hasMoreItems == true) {
          sethasNextPage(true)
        } else {
          sethasNextPage(false)
        }

      })
      .catch(function (error) { })
      .then(function () { });
  }


  const loadMoreItems = isNextPageLoading ? () => { } : loadNextPage;
  const fetchData = () => {

    const u = new URLSearchParams(queryParams).toString();
    setFilters(u)
    instance
      .get("/listings.php?page=" + page + "&" + u)
      .then(function (response) {
        setState(response.data)
        setItems([...response.data.items])
        setTitle(response.data.title)
        if (response.data.hasMoreItems == true) {
          sethasNextPage(true)
        } else {
          sethasNextPage(false)
        }
      })
      .catch(function (error) { })
      .then(function () { });
  }
  const goToPage = () => {
    const params = new URLSearchParams(location.search);

    params.set("search", filterText);
    if (filterText == '') params.delete("search");
    navigat(`${location.pathname}?${params.toString()}`);
  };

  useEffect(() => {
    fetchData()
     const name = searchParams.get("search");
    if (name) {
      setFilterText(name)
    } else {
      setFilterText('')
    }
  }, [location, page]);




  return (
    <div className="pt-4">
      {state.items && (
        <>
          {search_visible ? <div className="mb-3">
            <InputGroup>
              <Form.Control type="text" name="name1" placeholder="Search" value={filterText} onChange={e => setFilterText(e.target.value)} />

              <Button variant="warning" id="button-addon2" onClick={() => goToPage()}>
                Search
              </Button>
            </InputGroup>
          </div> : ' '}
          <div className="d-none align-items-center justify-content-between mb-3 ">
            <h2 className="mb-0 fs-5 fw-bold">{state.title} </h2>
            <UiButton title="Filter" onClick={() => showFilter()} className="btn btn-warning" />
          </div>
          <div className="">



            <>

              {state.items && u_items.length > 0 ?
                <>

                  <InfiniteScroll
                    dataLength={u_items.length}
                    next={loadMoreItems}
                    hasMore={hasNextPage}
                    height={elmheight}
                    loader={<BgLoader />}
                    scrollableTarget="parentelm"

                  >
                    <div className="">
                      {u_items.map((item, index) => (
                        <UpdateItem content={item} key={index} key1={index} />
                      ))}
                    </div>

                  </InfiniteScroll>
                </>
                : state.items && u_items.length == 0 && <div className="d-flex align-items-center justify-content-center mt-3"><TableZero title="listings"></TableZero></div>
              }
            </>
          </div>
        </>
      )}
    </div>
  );
}
